import requset from '@/utils/requset';

export function apiCheckTenant(tenant: string, domain: string) {
	return requset.get(`${domain}iam/v1/organization/check?organization_name=${tenant}`);
}

export function apiLookupTenant(params: any) {
  return requset.get(`/sswm/v1/lookup/${params.name}`)
  // .catch(() => {
  //   return Promise.resolve({
  //     "code": 0,
  //     "message": "success",
  //     "data": {
  //         "organization_name": "mycorp",
  //         "cluster_name": "us-cluster",
  //         "domain": "https://mycorp.iam.splashtop.com",
  //         "organization_type": "test"
  //     }
  //   });
  // })
}

export enum TenantPlanCategory{
  ind='ind',
  teams='teams',
  ind_and_teams='ind_and_teams'
}

export interface LookupEmailResponse {
  organization_name: string;
  cluster_name: string;
  domain: string;
  organization_type: string;
  tenant_plan_category: TenantPlanCategory;
}

export function apiLookupEmail(email: string): Promise<LookupEmailResponse> {
  return requset.post('/sswm/v1/lookup_email', {
    data: {
      email,
    },
  })
}
